/**
 * Parse Firebase Auth action URLs (oobCode / mode) for in-app redirects.
 * App.tsx handles resetPassword, verifyEmail, and signIn; recoverEmail is parsed but unused.
 */
export type AuthActionMode = 'resetPassword' | 'verifyEmail' | 'recoverEmail' | 'signIn';

export function parseAuthActionFromUrl(href: string): {
  mode: AuthActionMode | null;
  oobCode: string | null;
  continueUrl: string | null;
} {
  const url = new URL(href);
  return {
    mode: url.searchParams.get('mode') as AuthActionMode | null,
    oobCode: url.searchParams.get('oobCode'),
    continueUrl: url.searchParams.get('continueUrl'),
  };
}

export function getAuthActionSearchParams(href: string): URLSearchParams {
  return new URL(href).searchParams;
}

/** Rewrite a Firebase action URL onto a canonical in-app path, preserving all query params. */
export function buildAuthActionPath(path: string, href: string): string {
  const params = getAuthActionSearchParams(href);
  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}
